import axios from '../middleware/requestInterceptor';
import { DashboardCounter } from '../interface/DashboardCounter'

export const dashboardApi = {
    countAll: async () => {
            const response = await axios.get('/dashboard');
        return response.data as DashboardCounter;
    }
}
